module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.a613e81.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/font/roboto/Roboto-Bold.otf
// module id = ANwT
// module chunks = 0